module.exports = __webpack_public_path__ + "static/media/img_noble.82e3f038.jpg";